import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChanges: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    policyChangeEffectiveDate: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    description: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.Description:',
        defaultMessage: 'Description:'
    },
    secondaryNamedInsured: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.Secondary Named Insured',
        defaultMessage: 'Secondary Named Insured'
    },
    add: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.Add',
        defaultMessage: 'Add'
    },
    address: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.Address',
        defaultMessage: 'Address'
    },
    policyType: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.PolicyType.label',
        defaultMessage: 'What policy type is this associated with?'
    },
    baseState: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.BaseState',
        defaultMessage: 'Base State'
    },
    riskType: {
        id: 'premier.policychange.cybliaLine.views.policyChangesPage.riskType',
        defaultMessage: 'Risk Type'
    },
});
